import { getCookieAcceptance } from "../../services/service-cookies"
import { setCookie } from "../../services/service-cookies"

export default class CookiedisclaimerComponent {
  constructor(element) {
    this.el = element
	this.acceptbutton = this.el.querySelector(".cookie-accept-trigger")
    this.init()
  }
  
	init() {
		
		if(getCookieAcceptance('cookieconsent')) {
			this.el.classList.add('cookie-disclaimer-hide');
		}
		else {
			this.el.classList.remove('cookie-disclaimer-hide');
		}
		
		if (this.acceptbutton) {
			this.acceptbutton.addEventListener("click", event => {
				setCookie('cookieconsent', 'true', 30);
				this.el.classList.add('cookie-disclaimer-hide');	
				this.el.style.display = "none";
			})
		}
	}
}